module.exports = __webpack_public_path__ + "img/target-download.c2f2ca04.png";